module.exports = __webpack_public_path__ + "img/social_host.fc0c2ba1.svg";